import { createStyles } from '@mantine/core';

const IFRAME_HEIGHT = 640;

export const useGameplayLearnHowModalStyles = createStyles((theme) => ({
  body: {
    width: '95vw',
    maxWidth: 960,
  },
  button: {
    marginTop: theme.other.spacing._24,
  },
  iframeContainer: {
    marginTop: theme.other.spacing._16,
    marginBottom: theme.other.spacing._16,
    borderRadius: theme.other.spacing._8,
    overflow: 'hidden',
    position: 'relative',
    height: IFRAME_HEIGHT,
  },
  iframe: {
    width: '100%',
    height: IFRAME_HEIGHT,
    border: 'none',
  },
  loadingOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: theme.white,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.other.spacing._8,
  },
}));
